import dayjs from 'dayjs';
import Countdown from 'react-countdown';
import _ from 'lodash';
import { useState, useEffect, useMemo, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card, Breadcrumb, Container, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaFilePdf, FaHeart, FaRegHeart, FaFileImport } from 'react-icons/fa';
import { Storage } from 'aws-amplify';
import { TbFileEuro } from 'react-icons/tb';
import { Column } from 'react-table';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import useTiassistoStore from '../../store/TiassistoStore';
import TiassistoPudList from '../../components/TiAssisto/PudList/TiassistoPudList';
import toaster from '../../utils/toaster';
import Restricted from '../../components/Restricted/Restricted';
import { useApiClient } from '../../hooks/useApiClient';
import { useAuth } from '../../hooks/useAuth';
import {
	HideVehicleRequestDTO,
	ReleaseVehicleOptionsRequestDTO,
	RenewVehicleOptionsRequestDTO,
	OffertaEntity,
	VehicleStateEnum,
	VehicleUpdateRequestDTO,
	RoleEnum,
	TiassistoGetDriveItEasyStatusRequest,
	DealerDTO,
} from '../../api';
import OptionActionModal from '../../components/modals/optionActionModal';
import VehiclePdfTemplate from '../../components/VehicleDetails/VehiclePdfTemplate';
import type { QuotationPdfTag } from 'src/quotations/types';
import { calcRemaingOptionTime, getUrl, randomString } from '../../utils';
import CountdownDisplay from '../../components/CountdownDisplay/CountdownDisplay';
import { MakeAvailableVehicleRequestDTO } from '../../api/models/MakeAvailableVehicleRequestDTO';
import { useRefresh } from '../../hooks/useRefresh';
import { VehicleInEvidenzaToggleDTO } from '../../api/models/VehicleInEvidenzaToggleDTO';
import { InformationRequestDTO } from '../../api/models/InformationRequestDTO';
import TableContainer from '../../components/genericTable/TableContainer';
import { columnsData } from './columnsData';
import { GTMsendEvent } from '../../utils/trackingGA4';
import { useAiContext } from '../../context/AiContext';
import { FORMAT_DATE_TIME } from '../../utils/constants';
import { OpportunityStageEnum } from '../../api/';
import VehicleCardBody from '../../components/VehicleCardBody/VehicleCardBody';
import { OpportunityEntity } from '../../api/models/AccountEntity';
import QuickoPdfTemplate from '../../components/QuickoPdfTemplate/QuickoPdfTemplate';
import HistoryPudList from '../../components/TiAssisto/HistoryPudList/HistoryPudList';
import './DetailsPage.scss';
import VehicleAccordion from '../../components/VehicleAccordion/VehicleAccordion';
import VehicleStatusAccordion from '../../components/VehicleStatusAccordion/VehicleStatusAccordion';
import TiassistoElement from '../../components/TiAssisto/TiassistoElement';
import { dealersMap } from 'src/utils/users';
import * as PdfStore from '../../store/PdfStore';
import { DriveItEasyStatusEnum } from '../../api/models/Enums';
import DetailsActionsDropdown from '../../components/DetailsActionsDropdown/DetailsActionsDropdown';
import QuickoModal from 'src/components/AiQuotation/modals/quickoModal';
import usePdfStore from '../../store/PdfStore';
import { resolveMotornetImages } from '../../utils/vehicleImages';
import { PdfSource, PdfSourceType } from '../../constants/pdfConstants';
import { CreateQuickoReportModal } from 'src/components/Reports/CreateQuickoReportModal';
import { StellantisRequestQuoteModal } from 'src/components/Stellantis';
import { useQuery } from '@tanstack/react-query';
import { useStellantisActions } from 'src/store/StellantisStore';

interface Servizi {
	value: string;
	label: string;
}

const servizi: Servizi[] = [
	{ value: 'gomme', label: i18next.t('tyres') },
	{ value: 'rca', label: i18next.t('rca') },
	{ value: 'incendio_furto', label: i18next.t('i_f') },
	{ value: 'kasco', label: i18next.t('kasko') },
	{ value: 'vettura_sostitutiva', label: i18next.t('replacement_vehicle') },
];

const DetailsPage = () => {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const { apiClient, handleApi, handleApiResponse } = useApiClient();
	const { user, userRole, userReferencePartnerList, isSalesStellantis, isSalesFacile} = useAuth();
	const [allVehicleOpportunities, setAllVehicleOpportunities] = useState<
		OpportunityEntity[]
	>([]);
	const [statoVeicolo, setStatoVeicolo] = useState(
		null as VehicleStateEnum | null
	);
	const [downlodPdfValues, setDownlodPdfValues] = useState(null);
	const [opportunity, setOpportunity] = useState<OpportunityEntity | null>(
		null
	);
	const [preferiti, setPreferiti]: [any, any] = useState(null);
	const [isModalVisibile, setModalVisibility] = useState<boolean>(false);
	const [modalType, setModalType] = useState('');
	const [extensionNum, setExtensionNum] = useState(0);
	const [modalParams, setModalParams] = useState(null);
	const [quickoPdfData, setQuickoPdfData] = useState(null);
	const [response, setResponse]: [any, any] = useState(null);
	const [pdfImageList, setpdfImageList] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const [isReoptionable, setIsReoptionable] = useState(true);
	const [isActionForbidden, setIsActionForbidden] = useState<boolean>(false);
	const [timestamp, setTimestamp] = useState(0);
	const [inEvidenza, setInEvidenza] = useState(false);
	const [licensePlate, setLicensePlate] = useState('');
	const refresh = useRefresh();
	const { setQuotReqState, cleanAiContext, setQuotations, setCloseModalsCallback, showSignalingModal } = useAiContext();
	const aiQuotationRef = useRef<HTMLDivElement>(null);
	const [driveItEasyStatus, setDriveItEasyStatus] =
		useState<DriveItEasyStatusEnum>(DriveItEasyStatusEnum.SOSPESO);
	const { t } = useTranslation();
	const { setPdfDetail, setPdfQuickoDetail, pdfSource, setQuickoGtmSendData } =
		usePdfStore();
	const { setDieStatusData } = useTiassistoStore();
	const [isVisibleQuickoModal, setIsVisibleQuickoModal] = useState(false);
	const { openRequestQuoteModal } = useStellantisActions();

	const canCreateQuoteIfUnquotable = useMemo(() => {
		return true;
		// if (![RoleEnum.SALES, RoleEnum.SALES_DEALER].includes(userRole)) {
		// 	return false;
		// }

		// if (isSalesStellantis || isSalesFacile) {
		// 	return false
		// }

		// return true;
	}, [userRole, isSalesStellantis, isSalesFacile]);

	const closeModal = () => {
		setModalType('');
		setModalVisibility(false);
	};

	const showModal = (type, params?: any) => {
		setModalType(type);
		setModalParams(params || response);
		setModalVisibility(true);
	};

	const closeQuickoModal = () => {
		setIsVisibleQuickoModal(false);
	};

	const wasActionDoneByCurrentUser = (stateType, currentState) => {
		return (
			currentState?.type === stateType && currentState?.utente === user.username
		);
	};

	const closeAllModals = () => {
		closeQuickoModal();
		closeModal();
	};

	useEffect(() => {
		setCloseModalsCallback(closeAllModals)
		return () => {
			setCloseModalsCallback(null)
		}
	}, [])

	useEffect(() => () => setQuickoGtmSendData(null), [])

	const wasActionDoneByMaster = () => {
		// take the user of the current state
		if (
			(response.stato_corrente?.type === VehicleStateEnum.OPZIONATO ||
				response.stato_corrente?.type === VehicleStateEnum.OSCURATO) &&
			[RoleEnum.BACKOFFICE, RoleEnum.AREA_MANAGER].includes(userRole)
		) {
			const userCurrentState = response.stato_corrente.utente;
			handleApi(
				apiClient.userController.getRegisterSingleUser(userCurrentState)
			)
				.then((userUpdatedLatestState) => {
					// check if the user is a master and it is not the current role
					if (userUpdatedLatestState.role === RoleEnum.MASTER) {
						setIsActionForbidden(true);
					}
				})
				.catch((err) => {});
		}
	};

	const displayCanoneMinimo = (importoPrivato, importoAzienda) => {
		if (!importoPrivato && !importoAzienda) return '-';

		if (importoPrivato === null) {
			return importoAzienda.toLocaleString('it', {
				minimumFractionDigits: 2,
			});
		}

		if (importoAzienda === null) {
			return importoPrivato.toLocaleString('it', {
				minimumFractionDigits: 2,
			});
		}

		// if both importoAzienda and importoPrivato are NOT null, compare the 2 and return the min
		return Math.min(importoPrivato, importoAzienda).toLocaleString('it', {
			minimumFractionDigits: 2,
		});
	};

	const displayIvaStr = (importoPrivato, importoAzienda) => {
		if (!importoPrivato && !importoAzienda) return '';
		if (!importoPrivato) return i18next.t('vat_excluded');
		if (!importoAzienda) return i18next.t('vat_included');

		const min = Math.min(importoPrivato, importoAzienda);

		return min === importoPrivato
			? i18next.t('vat_included')
			: i18next.t('vat_excluded');
	};

	const coundownRenderer = ({
		days,
		formatted: { hours, minutes, seconds },
		completed,
	}) => {
		if (completed) {
			return <span className="topbar-scaduto">{t('expired')}</span>;
		} else {
			return (
				<span className="countdown">
					<div>
						<span className="countdown-val">{days}</span>
						<span className="countdown-val-m">{t('days_shorted_string')}</span>
					</div>
					<div>
						<span className="countdown-val">{hours}</span>
						<span className="countdown-val-m">{t('hours_shorted_string')}</span>
					</div>
				</span>
			);
		}
	};

	const sendSelectActionToGA4 = (actiontype) => {
		GTMsendEvent({
			event: 'select_actions_sale',
			actionType: actiontype,
		});
	};

	const checkIsReOptionable = () => {
		if (response.stato_corrente?.type === VehicleStateEnum.DISPONIBILE) {
			// Il ruolo master può opzionare senza attendere
			if ([RoleEnum.ADMIN, RoleEnum.MASTER].includes(userRole)) {
				setIsReoptionable(true);
				return true;
			}
			const storico = response.storico_azioni;
			const { canBeOptioned, timestamp } = calcRemaingOptionTime(user, storico);
			if (canBeOptioned) {
				setIsReoptionable(true);
			} else {
				setIsReoptionable(false);
				setTimestamp(timestamp);
			}
		}
	};

	const makeAvailable = () => {
		const body: MakeAvailableVehicleRequestDTO = {
			vehicleId: response.id,
		};

		return handleApi(
			apiClient.vehicleActionsController.postVehiclesActionsMakeAvailable(body)
		)
			.then((res) => {
				toaster.success(i18next.t('vehicle_made_available_successfully'));
				GTMsendEvent({
					event: 'complete_actions_sale',
					actionType: 'rendi_veicolo_disponibile',
				});
				refresh();
			})
			.catch((err) => {
				toaster.error(err.message || i18next.t('error_sending_data'));
			});
	};

	const getUserDealer = async () => {
		if (
			[RoleEnum.SALES, RoleEnum.SALES_DEALER, RoleEnum.SALES_INTERNAL].includes(
				userRole
			)
		) {
			if (user.attributes['custom:reference_partner']) {
				const userDealers = JSON.parse(
					user.attributes['custom:reference_partner']
				);

				if (userDealers.length) {
					const userDealer = userDealers[0].toUpperCase();
					const dealers: DealerDTO[] = await handleApiResponse(
						apiClient.dealerController.getRegisterDealers()
					);

					for (let d of dealers) {
						let ragioneSociale = d.ragione_sociale
							.toUpperCase()
							.replaceAll(' ', '_');

						if (
							ragioneSociale === userDealer ||
							(dealersMap[d.ragione_sociale] &&
								dealersMap[d.ragione_sociale] === userDealer)
						) {
							return d;
						}
					}
				}
			}
		}

		if (!user.attributes['custom:reference_partner']) {
			return null;
		}
		const userDealers = JSON.parse(user.attributes['custom:reference_partner']);

		if (!userDealers.length) {
			return null;
		}

		const userDealer = userDealers[0].toUpperCase();

		const dealers: DealerDTO[] = await handleApiResponse(
			apiClient.dealerController.getRegisterDealers()
		);

		for (let d of dealers) {
			let ragioneSociale = d.ragione_sociale.toUpperCase().replaceAll('_', ' ');

			if (
				ragioneSociale === userDealer ||
				(dealersMap[d.ragione_sociale] &&
					dealersMap[d.ragione_sociale] === userDealer)
			) {
				return d;
			}
		}
		return null;
	};

	const collectPdfData = async (values: any) => {
		let res: any = {};

		try {
			let dealer = await getUserDealer();

			if (dealer?.logo && dealer.logo.length) {
				res.logo = dealer.logo;
			}
		} catch (err: any) {
			toaster.error(err.message || i18next.t('error_sending_data'));
		} finally {
			if (res && res.logo) {
				const logoDealerLink: string = await Storage.get(res.logo, {
					bucket: process.env.REACT_APP_AWS_STORAGE_BUCKET_DEALER_LOGO,
				});

				res.logo = logoDealerLink;
			}

			values = { dealerDetail: res || null, ...values };
			return values;
		}
	};

	const resolveVehicleImages = async (): Promise<any[]> => {
		const images = await resolveMotornetImages(
			apiClient,
			response?.dati_veicolo?.vehicle_code,
			response?.dati_veicolo?.vehicle_kind
		);
		return images.length ? images : pdfImageList;
	};

	const downloadPdf = (values) => {
		const randString = randomString(10);
		Promise.all([collectPdfData(values), resolveVehicleImages()]).then(
			([result, imageList]) => {
				setPdfDetail({
					data: {
						idempotency: randString,
						pdf: _.clone(result),
						...response,
						image_list: imageList,
						quotation: { source: 'stock_offer', vehicle: { stockVehicleId: id ?? null } } as QuotationPdfTag,
					},
				});

				closeModal();
			}
		);
	};

	// API calls from onSubmitFn in optionActionsModal START
	const hideOption = (values) => {
		const body: HideVehicleRequestDTO = values;
		body.vehicleId = id!;

		return handleApi(
			apiClient.vehicleActionsController.postVehiclesActionsHide(body)
		);
	};

	const uploadPdfActions = (values) => {
		const body: VehicleUpdateRequestDTO = values;

		return handleApi(
			apiClient.vehicleController.putVehicles(id as string, body)
		);
	};

	const releaseOption = (values) => {
		const body: ReleaseVehicleOptionsRequestDTO = {
			vehicleId: id!,
		};

		return handleApi(
			apiClient.vehicleActionsController.postVehiclesActionsRelease(body)
		);
	};

	const renewOption = (values) => {
		const body: RenewVehicleOptionsRequestDTO = values;
		body.vehicleId = id!;

		return handleApi(
			apiClient.vehicleActionsController.postVehiclesActionsRenewal(body)
		);
	};

	const deleteOptions = async (values) => {
		const a = await Storage.remove(values?.document_name, {
			bucket: process.env.REACT_APP_AWS_STORAGE_BUCKET_VEHICLE,
		});

		if (response.stato_corrente?.opportunityId) {
			if (!opportunity) {
				toaster.error(`${i18next.t('opportunity_not_found')}...`);
				return;
			}

			const request = {
				name: opportunity.Name,
				commissions: opportunity.Provvigioni_canale__c,
				channel: opportunity.Canale__c,
				type: opportunity.Tipologia__c,
				dealerName: opportunity.Noleggiatore__c,
				note: opportunity.Messaggio__c || '',
				stageName: OpportunityStageEnum.suspended,
				driveItEasy: opportunity.DriveItEasy__c,
				driverEmail: opportunity.DriverEmail__c,
				targa: opportunity.Targa__c,
				telaio: opportunity.Telaio__c,
				provvigioniSegnalatore: opportunity.Provvigioni_Segnalatore__c,
				provvigioniPassive: opportunity.Provvigioni_passive__c,
				vehicle: {
					vehicleId: opportunity?.ID_Vehicle_HMP__c ?? null,
					customVehicle: opportunity?.ID_Vehicle_HMP__c
						? null
						: {
								brand: opportunity?.Brand__c ?? '',
								model: opportunity?.Modello__c ?? '',
						  },
				},
			};

			await handleApiResponse(
				apiClient.salesforceOpportunityController.editOpportunity(
					opportunity.Id,
					request
				)
			);
		}

		return handleApiResponse(
			apiClient.vehicleActionsController.deleteOption(id!)
		);
	};

	const deleteVehicle = (values) => {
		return handleApi(apiClient.vehicleController.deleteVehicles(id!));
	};

	const hideRenew = (values) => {
		const body: HideVehicleRequestDTO = values;
		body.vehicleId = id!;

		return handleApi(
			apiClient.vehicleActionsController.postVehiclesActionsHideRenew(body)
		);
	};

	const toggleInEvidenza = async (values) => {
		const inEvidenza = !values.inEvidenza;
		const body: VehicleInEvidenzaToggleDTO = {
			in_evidenza: inEvidenza,
			vehicleId: id!,
		};

		if (response.lista_offerte.length === 0 && !values.inEvidenza) {
			toaster.info(i18next.t('warning_vehicle_has_no_linked_offers'));
		}

		return handleApi(apiClient.vehicleActionsController.toggleInEvidenza(body));
	};

	const deleteWishlistFunc = (vehicleId) => {
		handleApi(apiClient.vehicleController.deleteWishlist(vehicleId))
			.then((res) => {
				toaster.success(
					i18next.t('vehicle_successfully_removed_from_favorites')
				);
				GTMsendEvent({
					event: 'wishlist',
					wishlist_action: 'remove',
					item_name: `${response.dati_veicolo.marca} ${response.dati_veicolo.allestimento}`,
					item_category: response.dati_veicolo.marca,
					item_category2: `${response.dati_veicolo.modello} ${response.dati_veicolo.allestimento}`,
					item_category3: `${response.dettagli_veicolo.telaio} - ${response.dettagli_veicolo.targa}`,
					item_category4: `${response.dati_veicolo.alimentazione} ${response.dati_veicolo.carrozzeria}`,
					item_variant: `${response.dati_veicolo.cambio} - ${response.dati_veicolo.trazione}`,
					colour: `${response.dettagli_veicolo.colore_esterno} - ${response.dettagli_veicolo.colore_interno}`,
				});
				setLoading(false);
				refresh();
			})
			.catch((err) => {
				setLoading(false);
				toaster.error(err.message || i18next.t('error_deleting_data'));
			});
	};

	const addWishlistFunc = (vehicleId) => {
		handleApi(apiClient.vehicleController.postWishlist(vehicleId))
			.then((res) => {
				toaster.success(
					i18next.t('vehicle_added_to_favorites_consultant_will_contact')
				);
				GTMsendEvent({
					event: 'wishlist',
					wishlist_action: 'add',
					item_name: `${response.dati_veicolo.marca} ${response.dati_veicolo.allestimento}`,
					item_category: response.dati_veicolo.marca,
					item_category2: `${response.dati_veicolo.modello} ${response.dati_veicolo.allestimento}`,
					item_category3: `${response.dettagli_veicolo.telaio} - ${response.dettagli_veicolo.targa}`,
					item_category4: `${response.dati_veicolo.alimentazione} ${response.dati_veicolo.carrozzeria}`,
					item_variant: `${response.dati_veicolo.cambio} - ${response.dati_veicolo.trazione}`,
					colour: `${response.dettagli_veicolo.colore_esterno} - ${response.dettagli_veicolo.colore_interno}`,
				});
				setLoading(false);
				refresh();
			})
			.catch((err) => {
				setLoading(false);
				toaster.error(err.message || i18next.t('error_saving_data'));
			});
	};

	const requestInformations = (informations) => {
		const services = Object.keys(informations.servizi)
			.filter(
				(key) =>
					informations.servizi[key].value !== '' &&
					informations.servizi[key].value !== 0
			) // Filter out items with empty or zero values
			.map((key) => {
				const { label, value } = informations.servizi[key];
				return `${key}: ${label} ${value}`;
			});

		const body: InformationRequestDTO = {
			...informations,
			elenco_servizi: services,
			marca: response.dati_veicolo.marca,
			modello: response.dati_veicolo.modello,
		};

		return handleApi(apiClient.vehicleController.sendQuationRequest(id!, body));
	};

	const downloadQuotationPdf = (values) => {
		const userName = user?.attributes.given_name ?? '';
		const userSurname = user?.attributes.family_name ?? '';
		const userMail = user?.attributes.email ?? '';
		const userPhone = user?.attributes['custom:phone'] ?? '';
		const typeTemplate = 'quickoQuotation';

		const pdfData = {
			...values,
			userName,
			userSurname,
			userMail,
			userPhone,
			typeTemplate,
		};
		Promise.all([collectPdfData(pdfData), resolveVehicleImages()]).then(
			([result, imageList]) => {
				setPdfQuickoDetail({
					data: {
						pdf: _.clone(result),
						...response,
						image_list: imageList,
						quotation: { source: 'stock_quicko', vehicle: { stockVehicleId: id ?? null } } as QuotationPdfTag,
					},
				});
			}
		);
	};

	/**
	 * If { activeOpportunityId } is given, it will be set as the active opportunity for
	 * a vehicle which has been optionated or sold
	 */
	const loadVehicleOpportunities = (vehicleId, activeOpportunityId = null) => {
		handleApi(
			apiClient.salesforceOpportunityController.getOpportunities({ vehicleId })
		).then((res) => {
			setAllVehicleOpportunities(res.data);

			if (activeOpportunityId) {
				const activeOpportunity = res.data.find(
					(o) => o.Id === activeOpportunityId
				);

				if (activeOpportunity) {
					setOpportunity(activeOpportunity);
				}
			}
		});
	};

	const loadVehicleOpportunity = (id) => {
		handleApi(
			apiClient.salesforceOpportunityController.getOpportunity(id)
		).then((res) => {
			if (res.data.length) {
				setOpportunity(res.data[0]);
			}
		});
	};

	const sendVehicleGTMEvent = (
		event_name: string,
		vehicleDetails,
		extras = {}
	) => {
		GTMsendEvent({
			event: event_name,
			item_id: vehicleDetails.dettagli_veicolo.nr_ordine,
			item_name: `${vehicleDetails.dati_veicolo.marca} - ${vehicleDetails.dati_veicolo.modello} ${vehicleDetails.dati_veicolo.allestimento}`,
			affiliation: userReferencePartnerList?.[0],
			dealer: vehicleDetails.dettagli_veicolo?.dealer,
			item_category: vehicleDetails.dati_veicolo.marca,
			item_category2: `${vehicleDetails.dati_veicolo.modello} ${vehicleDetails.dati_veicolo.allestimento}`,
			item_category3: vehicleDetails.dettagli_veicolo.codice_costruttore,
			item_category4: vehicleDetails.dettagli_veicolo.stato_disp,
			price:
				parseFloat(
					displayCanoneMinimo(
						vehicleDetails?.lista_offerte[0]?.importo_privato,
						vehicleDetails?.lista_offerte[0]?.importo_azienda
					)
				) || 0,
			advance: vehicleDetails.lista_offerte[0]?.anticipo,
			...extras,
		});
	};

	// API calls
	useEffect(() => {
		// GET SINGLE VEHICLE BY ID
		handleApi(apiClient.vehicleController.getVehicles1(id!))
			.then((res) => {
				// Veicolo non a sistema (eliminato).
				if (!res) {
					toaster.error(i18next.t('error_vehicle_not_found'));
					return;
				}
				if (res?.lista_offerte) {
					res.lista_offerte = res.lista_offerte
						// Filter in only the offers that have either importo_azienda or importo_privato valorized
						.filter((offer) => {
							return (
								(offer.importo_azienda !== null &&
									offer.importo_azienda !== 0) ||
								(offer.importo_privato !== null && offer.importo_privato !== 0)
							);
						})
						// Handle zero values and avoid ignoring offers completely
						.map((offer) => {
							if (offer.importo_privato === 0) offer.importo_privato = null;
							if (offer.importo_azienda === 0) offer.importo_azienda = null;
							return offer;
						})
						// Sort by minimum value between importo_azienda and importo_privato
						.sort((a: OffertaEntity, b: OffertaEntity) => {
							let min1 = a.importo_azienda ?? a.importo_privato;
							let min2 = b.importo_azienda ?? b.importo_privato;

							if (min1 === undefined && min2 === undefined) {
								return 0;
							}

							return min1! > min2! ? 1 : min2! > min1! ? -1 : 0;
						});
				}

				if (res.dettagli_veicolo) {
					setInEvidenza(res.dettagli_veicolo.in_evidenza);
				}

				if (res.image_list && res.image_list.length > 0) {
					setpdfImageList(res.image_list);
				}

				// OPTIONALS deducat VAT and SUM
				setQuotReqState((prevState) => {
					const updatedOptionals = res.optionals.map((optional) => {
						return {
							// deduct VAT
							...optional,
							valore: parseFloat((optional.valore / 1.22).toFixed(2)),
							isChecked: true,
						};
					});

					const totalOptionalsValue = updatedOptionals.reduce(
						(acc, optional) => {
							return acc + optional.valore;
						},
						0
					);
					return {
						...prevState,
						vehicleState: {
							...res,
							optionals: updatedOptionals,
						},
						optionalTotals: totalOptionalsValue,
					};
				});
				setResponse(res);
				sendVehicleGTMEvent('view_item', res);

				// GET OPPORTUNITIES
				if (
					[VehicleStateEnum.VENDUTO, VehicleStateEnum.OPZIONATO].includes(
						res.stato_corrente?.type
					) &&
					res.stato_corrente?.opportunityId
				) {
					loadVehicleOpportunity(res.stato_corrente?.opportunityId);
				}
				// setLoading(false);
			})
			.finally(() => {
				setLoading(false);
			});

		return () => {
			cleanAiContext();
		};
	}, []);

	useEffect(() => {
		if (response) {
			setStatoVeicolo(response.stato_corrente?.type);
			setPreferiti(response.preferiti);
			setExtensionNum(response.stato_corrente?.renewalsCounter || 0);
			checkIsReOptionable();
			wasActionDoneByMaster();
		}
	}, [response]);

	useEffect(() => {
		// GET DRIVE IT EASY STATUS
		const licensePlate =
			response?.dettagli_veicolo?.targa || opportunity?.Targa__c;
		setLicensePlate(licensePlate);

		if (licensePlate) {
			const driveItEasyStatusRequest: TiassistoGetDriveItEasyStatusRequest = {
				licensePlate,
				log: {
					operator: user?.username,
					description: "Recupero dello Stato del Servizio 'Drive It Easy Gold'",
				},
			};
			handleApi(
				apiClient.tiassistoController.getDriveItEasyStatus(
					driveItEasyStatusRequest
				)
			)
				.then((getDriveiteasyResponse) => {
					setDieStatusData(getDriveiteasyResponse);
					// IF the vehicle has drive it easy active then fetch active pud list
					if (
						getDriveiteasyResponse.status === 'success' &&
						getDriveiteasyResponse.serviceStatusDescription ===
							DriveItEasyStatusEnum.ATTIVO
					) {
						setDriveItEasyStatus(DriveItEasyStatusEnum.ATTIVO);
					} else if (
						getDriveiteasyResponse.status === 'success' &&
						getDriveiteasyResponse.serviceStatusDescription ===
							DriveItEasyStatusEnum.SOSPESO
					) {
						setDriveItEasyStatus(DriveItEasyStatusEnum.SOSPESO);
					}
				})
				.catch((error) => {});
		}
	}, [response, opportunity]);

	const isSoldOverXDaysAgo = useMemo(() => {
		if (response?.stato_corrente?.type !== VehicleStateEnum.VENDUTO) return false;
		const saleDate = response?.stato_corrente?.data_inizio;
		if (!saleDate) return false;
		return dayjs().isAfter(dayjs(saleDate).add(180, 'day'));
	}, [response]);

	const columns = useMemo(() => columnsData as Column<Object>[], []);
	const data = useMemo(() => response ?? [], [response]);

	const { data: quotables, isPending: isFetchingQuotables, isError } = useQuery({
    queryKey: ['quicko_quotables'],
    enabled: process.env.REACT_APP_QUICKO_ENABLED === '1',
    queryFn: async () => {
      return apiClient.motornetControllerService.getQuotable();
    },
    refetchOnWindowFocus: false,
    retry: false,
  });

	const isVehicleQuickable = useMemo(() => {
		if (isFetchingQuotables || isError || !response) return true;
		return quotables?.quotableIds?.includes(response?.id);
	}, [response, quotables, isFetchingQuotables, isError])

	const isQuickoDisabled = useMemo(() => {
		if (isFetchingQuotables || isError || !response) return true;
		return !isVehicleQuickable && ![RoleEnum.SALES, RoleEnum.SALES_DEALER, RoleEnum.SEGNALATORE].includes(userRole);
	}, [response, isFetchingQuotables, isError, isVehicleQuickable])

	return (
		<Container fluid>
			{!loading && response && (
				<>
					<OptionActionModal
						show={isModalVisibile}
						onHide={closeModal}
						modalType={modalType}
						details={modalParams}
						data={{ extensionNum, today: dayjs(), inEvidenza }}
						servizi={servizi}
						actionMethods={{
							downloadPdf,
							renewOption,
							deleteOptions,
							deleteVehicle,
							hideOption,
							releaseOption,
							hideRenew,
							toggleInEvidenza,
							uploadPdfActions,
							requestInformations,
							downloadQuotationPdf,
						}}
					/>

					<Breadcrumb>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: '/available-vehicles' }}
						>
							{t('vehicles_list')}
						</Breadcrumb.Item>
						<Breadcrumb.Item active>
							{`${response?.dati_veicolo.marca} ${response?.dati_veicolo.modello}`}
						</Breadcrumb.Item>
					</Breadcrumb>

					<Card className="details-topbar mt-2">
						<Card.Body className="p-0 pb-2 pb-md-0">
							<Row>
								<Col className="text-sm-start d-flex">
									{statoVeicolo === VehicleStateEnum.OPZIONATO && (
										<Row className="mx-0 my-1">
											<Col sm={12} className="d-flex">
												<div className="topbar-scadenza-label">
													{t('option_expiration')}:
												</div>
												<div className="topbar-scadenza-value ms-1">
													<span className="topbar-date">
														{dayjs(
															response?.stato_corrente?.data_scadenza
														).format(FORMAT_DATE_TIME)}
													</span>
													<span className="ms-2 topbar-countdown">
														<Countdown
															date={
																response?.stato_corrente?.data_scadenza
																	? new Date(
																			response?.stato_corrente?.data_scadenza
																	  )
																	: new Date()
															}
															renderer={coundownRenderer}
														/>
													</span>
												</div>
											</Col>
											<Col sm={12}>
												<div className="topbar-renewalsCounter">
													{t('remaining_extensions')}:
													<span className="renewalsCounter-value">
														{1 - extensionNum}
													</span>
												</div>
											</Col>
										</Row>
									)}
									{statoVeicolo === VehicleStateEnum.OSCURATO && (
										<Row className="mx-0 my-1">
											<Col sm={12} className="d-flex">
												<div className="topbar-scadenza-label">
													{t('hide_expiration')}:
												</div>
												<div className="topbar-scadenza-value ms-1">
													<span className="topbar-date">
														{dayjs(
															response?.stato_corrente?.data_scadenza
														).format(FORMAT_DATE_TIME)}
													</span>
													<span className="ms-2 topbar-countdown">
														<Countdown
															date={
																response?.stato_corrente?.data_scadenza
																	? new Date(
																			response?.stato_corrente?.data_scadenza
																	  )
																	: new Date()
															}
															renderer={coundownRenderer}
														/>
													</span>
												</div>
											</Col>
											<Col sm={12}>
												<div className="topbar-renewalsCounter">
													{t('number_extensions')}:
													<span className="renewalsCounter-value">
														{response?.stato_corrente?.renewalsCounter}
													</span>
												</div>
											</Col>
										</Row>
									)}
									{statoVeicolo === VehicleStateEnum.DISPONIBILE && (
										<div style={{ display: 'flex' }}>
											<div
												className={
													'd-block text-center d-md-inline-block topbar-stato-veicolo ' +
													statoVeicolo
												}
											>
												{t('vehicle_available')}
											</div>

											{(!isReoptionable && timestamp) ? (
												<div className="topbar-scadenza-value optionable-countdown-message">
													<div className="topbar-date">
														{t('you_can_option_this_vehicle_in')}
													</div>

													<div className="topbar-renewalsCounter">
														<CountdownDisplay timestamp={timestamp} />
													</div>
												</div>
											) : (
												''
											)}
										</div>
									)}

									{statoVeicolo === VehicleStateEnum.VENDUTO && (
										<div
											className={
												'd-block text-center d-md-inline-block topbar-stato-veicolo ' +
												statoVeicolo
											}
										>
											{t('vehicle_sold')}
										</div>
									)}
								</Col>
								<Col md={7} className="text-sm-end d-flex align-items-center justify-content-end">
								<div className="me-1 p-1">
									<Restricted
										to={[
											RoleEnum.BACKOFFICE,
											RoleEnum.AREA_MANAGER,
											RoleEnum.SALES,
											RoleEnum.SALES_INTERNAL,
											RoleEnum.MASTER,
											RoleEnum.ADMIN,
										]}
									>
										<Button
											disabled={
												statoVeicolo !== VehicleStateEnum.DISPONIBILE &&
												statoVeicolo !== VehicleStateEnum.OSCURATO
											}
											className="mx-1 align-text-bottom btn"
											onClick={() => {
												navigate(
													getUrl('/opportunities/new', {
														from: 'vehicle',
														vehicle_id: response.id,
														action: 'send_docs',
													})
												);
											}}
										>
											<FaFileImport className="fs-5" /> {t('send_docs')}
										</Button>
									</Restricted>

									{process.env.REACT_APP_QUICKO_ENABLED === '1' &&
										response?.stato_corrente?.type !==
											VehicleStateEnum.VENDUTO &&
										userRole !== RoleEnum.FLEET_MANAGER && (
											<OverlayTrigger
												placement='top'
												overlay={isQuickoDisabled
														? <Tooltip>{t('quicko_button_disabled_unquotable', { defaultValue: 'Non sono disponibili offerte per questo veicolo' })}</Tooltip>
														: <span/>
													}
											>
												<span className="d-inline-block">
													<Button
														id="quicko-not-quickable"
														className="mx-1 align-text-bottom btn"
														disabled={isQuickoDisabled}
														onClick={async () => {
															setQuotations(null);
															if (canCreateQuoteIfUnquotable && !isVehicleQuickable) {
																const images = await resolveVehicleImages();
																openRequestQuoteModal?.({
																	marca: response?.dati_veicolo.marca,
																	modello: response?.dati_veicolo.modello,
																	allestimento: response?.dati_veicolo.allestimento,
																	images: images
																		.map((img: { url?: string }) => img.url)
																		.filter((url: string | undefined): url is string => !!url),
																}, 'details')
																return;
															}

															setIsVisibleQuickoModal(true);
															GTMsendEvent({
																event: 'CTA_quicko_details',
																evtCat: 'Quicko',
																evtAct: 'click',
																evtLab: 'details',
															});
														}}
													>
														<img
															src="/svg-icons/quicko-logo-q.png"
															alt="Quicko"
															style={{ width: '24px', height: '20px' }}
														/>
														&nbsp;QUICKO
													</Button>
												</span>
											</OverlayTrigger>
										)}

									<Restricted
										to={[
											RoleEnum.BACKOFFICE,
											RoleEnum.MASTER,
											RoleEnum.ADMIN,
											RoleEnum.AREA_MANAGER,
										]}
									>
										<Button
											className="mx-1 align-text-bottom btn"
											onClick={() => {
												showModal('uploadPdfActions');
												GTMsendEvent({
													event: 'CTA_upload_file',
													evtCat: 'offerta',
													evtAct: 'upload',
												});
											}}
										>
											<FaFilePdf className="fs-5" /> {t('upload')}
										</Button>
									</Restricted>

									<Restricted to={[RoleEnum.FLEET_MANAGER]}>
										{preferiti?.length > 0 ? (
											<button
												className="align-text-bottom btn btn-danger mt-1"
												onClick={() => deleteWishlistFunc(id)}
											>
												{t('remove_from_favourites')}{' '}
												<FaHeart className="fs-5" />
											</button>
										) : (
											<button
												className="align-text-bottom btn btn-primary mt-1"
												onClick={() => addWishlistFunc(id)}
											>
												{t('add_to_favourties')} <FaRegHeart className="fs-5" />
											</button>
										)}

										<Button
											className="mx-1 align-text-bottom btn me-3"
											onClick={() => {
												showModal('requestInformations');
												GTMsendEvent({
													event: 'CTA_ask_quotes',
													evtCat: 'ask_quotes',
													evtAct: 'click',
													evtLab: `${response.dati_veicolo.marca} ${response.dati_veicolo.allestimento}`,
												});
											}}
										>
											<TbFileEuro className="fs-5" />
											{t('quotation_request')}
										</Button>
									</Restricted>
									<DetailsActionsDropdown
										{...{
											showModal,
											statoVeicolo,
											sendSelectActionToGA4,
											makeAvailable,
											extensionNum,
											wasActionDoneByCurrentUser,
											inEvidenza,
											isReoptionable,
											isActionForbidden,
											isSoldOverXDaysAgo,
											vehicleId: id,
											vehicleResponse: response,
										}}
									/>
									</div>
								</Col>
							</Row>
						</Card.Body>
					</Card>

					{/* MAIN *************************************************/}
					<Card className="mt-4 main-container">
						<div className="ribbon-container">
							{response.dettagli_veicolo.in_evidenza ? (
								<div className="vehicle-evidenza-ribbon">
									{t('in_highlight').toUpperCase()}
								</div>
							) : (
								''
							)}
						</div>
						<VehicleCardBody data={response}>
							<Col sm={7}>
								{response?.lista_offerte?.length ? (
									<div className="price-container">
										{userRole !== RoleEnum.FLEET_MANAGER ? (
											<>
												<div className="small">{t('min_rental_fee')}</div>
												<span className="h1" style={{ fontSize: '2.4rem' }}>
													{displayCanoneMinimo(
														response?.lista_offerte[0].importo_privato,
														response?.lista_offerte[0].importo_azienda
													)}
												</span>
												<span className="text-start ms-2 lh-1 d-inline-block">
													<span className="fs-5">€</span>
													<span>/{t('month')}</span>
													<strong className="d-block">
														{displayIvaStr(
															response?.lista_offerte[0].importo_privato,
															response?.lista_offerte[0].importo_azienda
														)}
													</strong>
												</span>
												<div className="h5">
													{t('downpayment')} €
													{response?.lista_offerte[0].anticipo?.toLocaleString(
														'it'
													) || 0}
												</div>
											</>
										) : (
											''
										)}

										{userRole !== RoleEnum.FLEET_MANAGER ? (
											<div>
												<div className="small mt-3">
													{response?.lista_offerte[0].durata} {t('months')}
												</div>
												<div className="small">
													{response?.lista_offerte[0].km_totali?.toLocaleString(
														'it'
													)}{' '}
													{t('km_per_year')}
												</div>
											</div>
										) : (
											''
										)}
									</div>
								) : (
									<div className="text-muted">
										{t('no_offers_linked_to_this_vehicle')}
									</div>
								)}
							</Col>
						</VehicleCardBody>
					</Card>

					<div className="display-6 mt-5">{t('details')}</div>

					{/* DETAILS VEHICLE */}
					<VehicleStatusAccordion
						vehicle={response}
						{...{ statoVeicolo, opportunity }}
					/>

					{/* OFFERS LIST */}
					<Restricted
						to={[
							RoleEnum.MASTER,
							RoleEnum.BACKOFFICE,
							RoleEnum.SALES,
							RoleEnum.SALES_DEALER,
							RoleEnum.SALES_INTERNAL,
							RoleEnum.ADMIN,
							RoleEnum.AREA_MANAGER,
						]}
					>
						<div>
							<div className="display-6 mt-5">
								{t('available_price_combinations')}
							</div>

							<Card className="mt-3">
								<Card.Body>
									{response?.lista_offerte?.length ? (
										<TableContainer
											columns={columns}
											data={data.lista_offerte}
											loading={loading}
											error={null}
											showModalFunc={showModal}
										></TableContainer>
									) : (
										<div className="m-4 text-muted">
											{t('no_offers_linked_to_this_vehicle')}
										</div>
									)}
								</Card.Body>
							</Card>
						</div>
					</Restricted>

					<div className="display-6 mt-5">{t('discover_car_data')}</div>

					{/* DATI AUTO */}
					<VehicleAccordion vehicle={response} />

					{/* PDF template */}
					<VehiclePdfTemplate></VehiclePdfTemplate>

					<div style={{ display: 'none' }}>
						<QuickoPdfTemplate />
					</div>

					{/* QUICKO */}
					{process.env.REACT_APP_QUICKO_ENABLED === '1' &&
						response.dati_veicolo.jato_id &&
						response?.stato_corrente?.type !== VehicleStateEnum.VENDUTO && (
							<div ref={aiQuotationRef}></div>
						)}

					{/* TIASSISTO PUD LIST for FLEET MANAGER */}
					<TiassistoElement>
						<>
							{response?.stato_corrente?.type === VehicleStateEnum.VENDUTO && (
								<TiassistoPudList
									licensePlate={licensePlate}
									driveItEasyStatus={driveItEasyStatus}
								/>
							)}
							{response?.stato_corrente?.type === VehicleStateEnum.VENDUTO && (
								<>
									<HistoryPudList
										vehicleId={response?.dettagli_veicolo?.targa}
									/>
								</>
							)}
						</>
					</TiassistoElement>
				</>
			)}

			<QuickoModal
				showModal={showModal}
				closeFn={closeQuickoModal}
				isVisible={isVisibleQuickoModal}
				onConfirmEvent={(data) => {
					const quickoGtmSendData = {
						...data,
						supply: response.dati_veicolo?.alimentazione,
						colours: response.dettagli_veicolo?.colore_interno,
						chassis: response.dettagli_veicolo?.telaio,
						number_plate: response.dettagli_veicolo?.targa ?? '',
						body_car: response.dati_veicolo?.carrozzeria,
						notes: response.dettagli_veicolo?.note ?? '',
						item_id: response.dettagli_veicolo.nr_ordine,
						item_name: `${response.dati_veicolo.marca} - ${response.dati_veicolo.modello} ${response.dati_veicolo.allestimento}`,
						affiliation: userReferencePartnerList?.[0],
						dealer: response.dettagli_veicolo?.dealer,
						item_category: response.dati_veicolo.marca,
						item_category2: `${response.dati_veicolo.modello} ${response.dati_veicolo.allestimento}`,
						item_category3: response.dettagli_veicolo.codice_costruttore,
						item_category4: response.dettagli_veicolo.stato_disp,
						advance: response?.lista_offerte[0]?.anticipo,
						price:
							parseFloat(
								displayCanoneMinimo(
									response?.lista_offerte[0]?.importo_privato,
									response?.lista_offerte[0]?.importo_azienda
								)
							) || 0,
					};
					setQuickoGtmSendData(quickoGtmSendData);
					try {
						sendVehicleGTMEvent('complete_quicko_quotes', response, {
							...quickoGtmSendData,
							userId: user?.attributes?.sub,
						});
					} catch (error) {
						console.warn('[Horizon] Failed to send quicko GTM event.', error);
					}
				}}
			/>

			{showSignalingModal && <CreateQuickoReportModal />}
			{canCreateQuoteIfUnquotable ? <StellantisRequestQuoteModal /> : null}
		</Container>
	);
};

export default DetailsPage;
